import { defineStore } from "pinia";

export const useBelajarWajibReaderStore = defineStore({
  id: "belajarWajibReader",
  state: () => ({
    courseList: [],
    loadingGetCourses: false,
    errorGetCourses: false,

    materiList: [],
    doneTrophyWajib: 0,
    loadingGetMateriByType: false,
    errorGetMateriByType: false,

    microList: [],
    doneTrophyMicro: 0,
    loadingGetMateriMicro: false,
    errorGetMateriMicro: false,

    bahanList: [],
    loadingGetProgressMateriBySubmateri: {},

    evaluationAccess: {
      message: "",
      status: false,
    },
    loadingValidateEvaluationAccess: false,
    errorValidateEvaluationAccess: false,
    openSwajarOldDialog: false,
    textSwajarOldDialog: "",

    evaluationList: [],
    multipleChoiceNotStarted: {},
    loadingGetEvalByCourseId: false,
    errorGetEvalByCourseId: false,

    journalData: {},
    loadingGetJournal: false,
    errorGetJournal: false,

    loadingSetProgressMateri: false,
  }),
  getters: {
    filteredCourseData(state) {
      return (
        state.courseList.find(
          (key) =>
            key.angkatan.masterTypes.namaType ===
            localStorage.getItem("courseType"),
        ) || {}
      );
    },
    isCPNS() {
      return (
        JSON.parse(localStorage.getItem("dataPegawai"))?.statusPegawai ===
          "CPNS" || localStorage.getItem("courseType") === "CPNS"
      );
    },
  },
  actions: {
    async getCourses() {
      try {
        this.loadingGetCourses = true;

        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/courses/v2/getcoursebytoken`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          state.courseList = response?.peserta?.body || [];
        });
        localStorage.setItem(
          "courseList",
          JSON.stringify(response?.peserta?.body) || [],
        );
        this.errorGetCourses = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          (error.response?._data === "Token is invalid or unauthorized" ||
            error.response?._data === "Token is expired")
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetCourses = true;
        }
      } finally {
        this.loadingGetCourses = false;
      }
    },
    async getMateriByType() {
      this.loadingGetMateriByType = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const angkatan = courseData?.angkatan || {};
        const masterTypeId = angkatan.masterTypes?.id || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/materi/v2/getmateriwajib/${useSwajarKurikulumStore().materiType === "k2" ? "k2/" : ""}${masterTypeId}`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          state.materiList = response?.materiList || [];
          state.doneTrophyWajib = response?.doneThropy || 0;
        });
        this.errorGetMateriByType = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetMateriByType = true;
        }
      } finally {
        this.loadingGetMateriByType = false;
      }
    },
    async getMateriMicro() {
      this.loadingGetMateriMicro = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const angkatan = courseData?.angkatan || {};
        const masterTypeId = angkatan.masterTypes?.id || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/materi/v2/getmaterimicro/${masterTypeId}/${uuidCourse}`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          state.microList = response?.materiList || [];
          state.doneTrophyMicro = response?.doneThropy || 0;
        });
        this.errorGetMateriMicro = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetMateriMicro = true;
        }
      } finally {
        this.loadingGetMateriMicro = false;
      }
    },
    async getProgressMateriBySubmateri(idSubmateri) {
      this.loadingGetProgressMateriBySubmateri[idSubmateri] = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/progressmateri/v2/getprogressmateribysubmateri${useSwajarKurikulumStore().materiType === "k2" ? "-kdua" : ""}/${idSubmateri}/${
            useBelajarWajibReaderStore().filteredCourseData?.uuid || ""
          }`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          state.bahanList = response || [];
        });
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          useUserStore().$patch({
            snackStatus: "error",
            snackbar: true,
            messageSnack:
              error?.response?._data?.message || "Terjadi kesalahan.",
          });
          useBelajarWajibReaderStore().$patch((state) => {
            state.bahanList = [];
          });
        }
      } finally {
        this.loadingGetProgressMateriBySubmateri[idSubmateri] = false;
      }
    },
    async getJournal() {
      this.loadingGetJournal = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/jurnal/v2/jurnalByUuidCourse/${uuidCourse}`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          state.journalData = response || {};
        });
        this.errorGetJournal = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetJournal = true;
        }
      } finally {
        this.loadingGetJournal = false;
      }
    },
    async validateEvaluationAccess() {
      this.loadingValidateEvaluationAccess = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/evaluation${useSwajarKurikulumStore().materiType === "k2" ? "_kurikulum_dua" : ""}/v2/validasiAksesEvaluasi/${uuidCourse}`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          state.evaluationAccess = {
            message: response?.message || "",
            status: response?.status || false,
          };
        });
        this.errorValidateEvaluationAccess = false;
      } catch (error) {
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorValidateEvaluationAccess = true;
          if (error.response?.status === 409) {
            this.multipleChoiceNotStarted = {
              status: true,
              message: error.response?._data?.message || "",
            };
          } else if (error?.response?.status === 423) {
            this.openSwajarOldDialog = true;
            this.textSwajarOldDialog = error?.response?._data?.message || "";
          }
        }
      } finally {
        this.loadingValidateEvaluationAccess = false;
      }
    },
    async getEvaluationByCourseId() {
      this.loadingGetEvalByCourseId = true;
      try {
        const courseData =
          useBelajarWajibReaderStore().filteredCourseData || {};
        const uuidCourse = courseData?.uuid || "";
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-cache-reader"}/api/evaluation/v2/getByCourse/${uuidCourse}`,
          "GET",
        );
        useBelajarWajibReaderStore().$patch((state) => {
          const data = Object.keys(response).length > 0 ? response : {};
          state.evaluationList = data || [];
        });
        this.errorGetEvalByCourseId = false;
      } catch (error) {
        if (error.response?.status === 409) {
          useBelajarWajibReaderStore().$patch((state) => {
            state.multipleChoiceNotStarted = {
              status: true,
              message: error.response?._data.message || "",
            };
          });
        }
        if (
          error.response?.status === 401 &&
          error.response?._data === "Token is expired"
        ) {
          await useBelajarWajibStore().refreshToken();
        } else {
          this.errorGetEvalByCourseId = true;
        }
      } finally {
        this.loadingGetEvalByCourseId = false;
      }
    },
    async setProgressMateri(payload) {
      this.loadingSetProgressMateri = true;
      try {
        const response = await fetchBelajarWajib(
          useRequestEvent(),
          `/${this.isCPNS ? "cpns-orientation" : "swajar-transaction"}/api/${this.isCPNS ? "progressmateri/" : ""}v2/progressmateri/save${useSwajarKurikulumStore().materiType === "k2" ? "-kdua" : ""}`,
          "POST",
          payload,
        );
        useUserStore().$patch({
          snackStatus: "green",
          snackbar: true,
          messageSnack: "Sukses menambah progress materi.",
        });
        useBelajarWajibReaderStore().$patch((state) => {
          state.bahanList = response || [];
        });
      } catch (error) {
        useUserStore().$patch({
          snackStatus: "red",
          snackbar: true,
          messageSnack: error?.response?._data?.message || "Terjadi kesalahan.",
        });
      } finally {
        this.loadingSetProgressMateri = false;
      }
    },
  },
});
